module.exports = __webpack_public_path__ + "img/1577247744.3394e074.jpg";